import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from "../../utils/httpsRequest";


export const fetchNotification = createAsyncThunk(
  "category/fetchNotification",
  async (arg) => {
      return httpRequest(`${BASE_URL}/Notifications?PageSize=${arg.pageSize}&PageNumber=${arg.pageNumber}&NotificationType=${arg.notificationType}`);
  }
)

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    notification: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNotification.fulfilled, (state, action) => {
        state.loading = false;
        state.notification = action.payload;
      })
      .addCase(fetchNotification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  } 

});


export default notificationSlice.reducer;
